"use client";
import { Asset as e } from "../assets/Asset.js";
import { AssetSvg as t } from "../assets/AssetSvg.js";
import { jsx as n, jsxs as r } from "react/jsx-runtime";
import { useId as i } from "react";
//#region src/components/flags/TLFlag.tsx
var a = (e) => {
	let a = i();
	return /* @__PURE__ */ r(t, {
		viewBox: "0 0 24 24",
		fill: "none",
		...e,
		children: [/* @__PURE__ */ r("g", {
			clipPath: `url(#${a}-clip0_103_228)`,
			children: [
				/* @__PURE__ */ n("mask", {
					id: `${a}-path-1-inside-1_103_228`,
					fill: "white",
					children: /* @__PURE__ */ n("path", { d: "M0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12Z" })
				}),
				/* @__PURE__ */ n("path", {
					d: "M0 0.000244141H36V23.9998H0V0.000244141Z",
					fill: "#D80027"
				}),
				/* @__PURE__ */ n("path", {
					d: "M18 12L0 0.376709V3.48748L10.9565 12L0 20.5125V23.6233L18 12Z",
					fill: "#FFDA44"
				}),
				/* @__PURE__ */ n("path", {
					d: "M0 0.376709V23.6233L13.3043 12L0 0.376709Z",
					fill: "black"
				}),
				/* @__PURE__ */ n("path", {
					d: "M3.10663 9.00195L4.85825 10.6597L6.97614 9.50588L5.94093 11.6842L7.69248 13.3418L5.30101 13.0303L4.2658 15.2084L3.82311 12.8378L1.43164 12.5263L3.54938 11.3726L3.10663 9.00195Z",
					fill: "white"
				})
			]
		}), /* @__PURE__ */ n("defs", { children: /* @__PURE__ */ n("clipPath", {
			id: `${a}-clip0_103_228`,
			children: /* @__PURE__ */ n("path", {
				d: "M0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12Z",
				fill: "white"
			})
		}) })]
	});
}, o = {
	12: {
		Artwork: a,
		width: 12,
		height: 12
	},
	16: {
		Artwork: a,
		width: 16,
		height: 16
	},
	20: {
		Artwork: a,
		width: 20,
		height: 20
	},
	24: {
		Artwork: a,
		width: 24,
		height: 24
	}
}, s = ({ size: t = 16, ...r }) => /* @__PURE__ */ n(e, {
	source: o[t],
	frame: "circle",
	...r
});
//#endregion
export { s as TLFlag };
